import React from 'react'
import Popover from '../Popover'
import styles from '../../../CSS/main.css'
import Button, { ButtonIcon } from '../Button/Button'
import classNames from 'classnames'

type Props = {
  readonly open: boolean
  readonly onClose: () => void
  readonly title?: string
}

const Modal: React.FC<Props> = ({ open, onClose, children, title }) => {
  return (
    <Popover
      open={open}
      onClose={onClose}
      backdropClassNames={classNames([
        styles.ButtonCoverDelete,
        styles.CoverLight,
      ])}
      backdropStyle={{ display: 'block' }}>
      <div
        className={styles.Confirmation}
        style={{
          display: 'block',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}>
        <div className={styles.Content}>
          <ButtonIcon
            title={'Close'}
            additionalClassNames={[styles.MenuClose, styles.IconClose]}
            onClick={onClose}
          />
          <div className={styles.MenuHeader}>{title}</div>
          <div className={styles.MenuText}>{children}</div>
        </div>
      </div>
    </Popover>
  )
}

export default Modal
